import MiraSocket from "~/socket/mira.js";

export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    const miraSocket = new MiraSocket();
    // Inject miraSocket into nuxtApp
    return {
      provide: {
        miraSocket,
      },
    };
  }
});
